export const displayDatalist = [
  { value: "None", style: "hidden" },
  { value: "Inline", style: "inline" },
  { value: "Inline Block", style: "inline-block" },
  { value: "Block", style: "block" },
];
